import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSmartPowerReport from './reducers/smart-power-report.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SmartPowerReportEffects } from './effects/smart-power-report.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('smartPowerReportList', fromSmartPowerReport.reducer),
    StoreModule.forFeature('smartPowerReport', fromSmartPowerReport.smartPowerReportReducer),
    StoreModule.forFeature('smartPowerReportData', fromSmartPowerReport.smartPowerReportDataReducer),
    EffectsModule.forFeature([SmartPowerReportEffects])
  ]
})
export class SmartPowerReportModule { }
